import { Anchor, AnchorModel } from '@bpba/ui-components';
import styled from 'styled-components';
import {
  BorderProps,
  border,
  BoxShadowProps,
  boxShadow,
  OverflowProps,
  overflow,
  MaxWidthProps,
  maxWidth,
  SpaceProps,
  space,
  JustifyContentProps,
  justifyContent,
  flexDirection,
  FlexDirectionProps,
} from 'styled-system';
import { ComponentProps } from 'react';

export type GenericCardProps = {
  data: AnchorModel;
  children: React.ReactNode;
  /**indica si es el último elemento para omitir el margen derecho y el margen del fondo.*/
  isLast: boolean;
} & ComponentProps<typeof StyledLinkedComponentBase>;

export function GenericCard(props: GenericCardProps) {
  const { children, marginRight, marginBottom, ...otherProps } = props;
  return (
    <StyledLinkedComponentBase
      tabIndex={0}
      display="flex"
      flexDirection="column"
      overflow="hidden"
      width="100%"
      marginRight={props.isLast ? [] : marginRight}
      marginBottom={props.isLast ? [] : marginBottom}
      {...otherProps}
    >
      {children}
    </StyledLinkedComponentBase>
  );
}

type StyledLinkedComponentBaseProps = ComponentProps<typeof Anchor> & JustifyContentProps & BorderProps & BoxShadowProps & OverflowProps & MaxWidthProps & SpaceProps & FlexDirectionProps;
const StyledLinkedComponentBase = styled(Anchor)<StyledLinkedComponentBaseProps>(border, boxShadow, overflow, maxWidth, space, justifyContent, flexDirection, {
  transition: 'box-shadow 0.3s linear',
  '-webkit-transition': 'box-shadow 0.3s linear',
  '-moz-transition': 'box-shadow 0.3s linear',
  '-ms-transition': 'box-shadow 0.3s linear',
  '-o-transition': 'box-shadow 0.3s linear',
  '&:hover': {
    boxShadow: '0px 0px 8px 2px rgba(0,0,0,0.4)',
  },
});
